import { render } from "./system_notifications.html?vue&type=template&id=5c8b0bb2&external"
import script from "./system_notifications.js?vue&type=script&lang=js&external"
export * from "./system_notifications.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__